import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "configs/queryKey";
import { removeTokenInfo } from "utils/apiService/TokenInfo";

interface IProps {
  onClose: () => void;
  id: string;
}
const useRemoveTokenInfo = ({ onClose, id }: IProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation(async () => await removeTokenInfo(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.TOKEN_INFO]);
      onClose();
      toast({
        title: "Token info",
        description: "Remove a token successful",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    },
    onError: async (errors: any) => {
      const devMessage = errors?.response?.data?.devMessage || [];
      const errorMessage = errors?.response?.data?.errorMessage || "";
      const description = errorMessage + ":" + devMessage?.join(", ") || "";

      toast({
        title: "Token info",
        description,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export default useRemoveTokenInfo;
